import axios from 'axios';
import API_URL from './apiurl'


export const searchClubEvents = async (params) => {

    return await axios.post(`${API_URL.SEARCH_CLUBEVENTS_URL}`, params, { headers: null})
        .then(data => data.data)
        .catch(error => { throw error.response.data });
};